import { render } from "./PhoneCallList.vue?vue&type=template&id=20fcfaf9"
import script from "./PhoneCallList.vue?vue&type=script&lang=js"
export * from "./PhoneCallList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__